(function ($) {
  "use strict";
  $(document).ready(function () {
    $(".pop-up-cookies__btn").click(function() {
      $(".pop-up-cookies").fadeOut();
      localStorage.setItem("termCookies", true);
    });
    if(localStorage.getItem("termCookies")){
      $(".pop-up-cookies").hide();
    }else{
      $(".pop-up-cookies").show();
    }
  });
})(jQuery);